import React, { useContext } from 'react';
import { LanguageContext } from '../../index';

const CtaSection = (props) => {
    const { language } = useContext(LanguageContext);
    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const content = {
        pl: {
            signUp: "zapisz się",
            newsletter: "na nasz newsletter",
            email: "email",
            subscribe: "subskrybuj"
        },
        en: {
            signUp: "sign up",
            newsletter: "for our newsletter",
            email: "email",
            subscribe: "subscribe"
        }
    };

    const t = content[language] || content.en;

    return (
        <section className="call-action">
            <div className="container">
                <div className="call-action-inner">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="section-title text-white rmb-35">
                                <h6>{t.signUp}</h6>
                                <h2>{t.newsletter}</h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <form onSubmit={SubmitHandler} className="subscribe">
                                <input type="email" placeholder={t.email} required/>
                                <button type="submit" className="theme-btn style-two">{t.subscribe}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CtaSection;